// import { Divider, Grid, IconButton, Tooltip, Typography,Stack,ButtonGroup,Button,Menu,MenuItem } from "@mui/material";
// import { useState } from "react";

// import Close from '@mui/icons-material/Close';
// import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";

// const ViewMonthlyAttendanceActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, title, callback }) => {

//     const [selectedButton, setSelectedButton] = useState(null);
//     const [anchorEl, setAnchorEl] = useState(null);

//     const handleButtonClick = (buttonName) => {
//         setSelectedButton(buttonName);
//         setSelectedButtonName(buttonName);
//         handlecallProcess(buttonName);
//     };

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = (option) => {
//         setAnchorEl(null);
//         if (option === 'pdf') {
//             // handleExportPDF();
//             setSelectedButton('pdf');
//             setSelectedButtonName('pdf');
//         }
//         if (option === 'excel') {
//             // handleExportExcel();
//             setSelectedButton('excel');
//             setSelectedButtonName('excel');
//         }
//     };

//     return (

//         <Grid container justifyContent="space-between" alignItems="center" padding={0}>
//             {/* Left-aligned: Edit Employee */}
//             <Grid item>
//                 <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
//                     {title}
//                 </Typography>
//             </Grid>

//             {/* Right-aligned: Buttons */}
//             <Grid item>
//                 <Grid container alignItems="center">
//                     <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

//                     {/* Exit Employee */}
//                     <Grid item ml={1} mr={1}>
//                         <Tooltip title="Download Detail">
//                             {/* <IconButton
//                                 onClick={() => handleButtonClick('download')}
//                                 sx={{ display: 'flex', alignItems: 'center' }}
//                             >
//                                 <DownloadForOfflineIcon style={{ fontSize: "18px", color: selectedButton === 'download' ? "yellow" : "#009688" }} />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>Download</Typography>
//                             </IconButton> */}
//                             <Stack direction="row" spacing={2}>
//                                 <ButtonGroup variant="contained">
//                                     <Button startIcon={<FileDownloadIcon />}>Export</Button>
//                                     <Button
//                                         size="small"
//                                         onClick={handleClick}
//                                     >
//                                         <ArrowDropDownIcon />
//                                     </Button>
//                                 </ButtonGroup>
//                                 <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
//                                     <MenuItem onClick={() => handleClose('pdf')}>Export as PDF</MenuItem>
//                                     <MenuItem onClick={() => handleClose('excel')}>Export as Excel</MenuItem>
//                                 </Menu>
//                             </Stack>
//                         </Tooltip>
//                     </Grid>

//                     <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

//                     {/* Exit Employee */}

//                     <IconButton onClick={callback}>
//                         <Close style={{ fontSize: "14px", color: "#2196F3" }} />
//                     </IconButton>
//                     <Divider orientation="vertical" flexItem

//                     />
//                 </Grid>
//             </Grid>
//         </Grid>


//     )
// };
// export default ViewMonthlyAttendanceActionMenu;


import {
    Divider,
    Grid,
    IconButton,
    Tooltip,
    Typography,
    Stack,
    ButtonGroup,
    Button,
    Menu,
    MenuItem
} from "@mui/material";
import { useState } from "react";

import Close from '@mui/icons-material/Close';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const ViewMonthlyAttendanceActionMenu = ({
    selectedButtonName,
    setSelectedButtonName,
    handlecallProcess,
    title,
    callback
}) => {
    const [selectedButton, setSelectedButton] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (option) => {
        setAnchorEl(null);
        setSelectedButton(option);
        setSelectedButtonName(option);
        handlecallProcess(option); // Trigger export (e.g., 'pdf' or 'excel')
    };

    return (
        <Grid container justifyContent="space-between" alignItems="center" padding={0}>
            {/* Title */}
            <Grid item>
                <Typography
                    variant="h4"
                    sx={{
                        textAlign: "center",
                        width: "100%",
                        marginLeft: "10px",
                        alignItems: "center"
                    }}
                >
                    {title}
                </Typography>
            </Grid>

            {/* Actions */}
            <Grid item>
                <Grid container alignItems="center">
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Export Options */}
                    <Grid item >
                        <Tooltip title="Export Options">
                            <Stack direction="row" spacing={2}>
                                <ButtonGroup variant="standard" color="secondary">
                                    <Button startIcon={<FileDownloadIcon />}>Export</Button>
                                    <Button
                                        size="small"
                                        onClick={handleClick}
                                    >
                                        <ArrowDropDownIcon />
                                    </Button>
                                </ButtonGroup>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={() => setAnchorEl(null)}
                                >
                                    <MenuItem onClick={() => handleClose('pdf')}>Export as PDF</MenuItem>
                                    <MenuItem onClick={() => handleClose('excel')}>Export as Excel</MenuItem>
                                </Menu>
                            </Stack>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Close Button */}
                    <IconButton onClick={callback}>
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ViewMonthlyAttendanceActionMenu;
